// Shared Incident Tracking constants + helpers.

// Types per the client's Phase 1 answer ("complaint, criminal, maintenance"),
// plus a catch-all.
export const INCIDENT_TYPES = ["complaint", "criminal", "maintenance", "other"] as const;
export const INCIDENT_SEVERITIES = ["low", "medium", "high", "urgent"] as const;
export const INCIDENT_STATUSES = ["open", "under_review", "resolved", "closed"] as const;

const TYPE_LABELS: Record<string, string> = {
  complaint: "Complaint",
  criminal: "Criminal",
  maintenance: "Maintenance",
  other: "Other",
};

const STATUS_LABELS: Record<string, string> = {
  open: "Open",
  under_review: "Under review",
  resolved: "Resolved",
  closed: "Closed",
};

export function incidentTypeLabel(t: string | null): string {
  if (!t) return "—";
  return TYPE_LABELS[t] ?? t;
}

export function incidentStatusLabel(s: string): string {
  return STATUS_LABELS[s] ?? s;
}

export function severityLabel(s: string): string {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

export function incidentStatusBadge(s: string): string {
  if (s === "resolved") return "ok";
  if (s === "under_review") return "info";
  if (s === "closed") return "muted";
  return "warn"; // open
}

export function severityBadge(s: string): string {
  if (s === "urgent" || s === "high") return "alert";
  if (s === "medium") return "warn";
  return "muted"; // low
}

export function formatIncidentId(id: number): string {
  return "INC-" + String(id).padStart(3, "0");
}

// A stored timestamp ("YYYY-MM-DD HH:MM:SS" or ISO) → an <input type="datetime-local"> value.
export function toDatetimeLocal(s: string | null): string {
  if (!s) return "";
  return s.slice(0, 16).replace(" ", "T");
}
